<div id="page-wrapper" class="page-wrapper" *mobxAutorun>
    <dashboard-nav id="overview-header" [user]="store?.user" [term]="evn?.term" [campus]="store?.user?.campus"
        (onSignOut)="store?.signOut()">
    </dashboard-nav>
    <router-outlet></router-outlet>
</div>
